LANGUAGE_COOKIE = 'doterra_login_language';
DEFAULT_LANGUAGE = "en-us";

LANGUAGES = [
    {name: 'English (United States)', code: 'en-us'},
    {name: 'English (Australia)', code: 'en-au'},
    {name: 'English (New Zealand)', code: 'en-nz'},
    {name: 'English (Europe)', code: 'en-eu'},
    {name: 'English (Germany)', code: 'en-de'},
    {name: 'English (United Kingdom)', code: 'en-gb'},
    {name: 'English (Italy)', code: 'en-it'},
    {name: 'English (Russia)', code: 'en-ru'},
    {name: 'English (Canada)', code: 'en-ca'},
    {name: 'English (Central America)', code: 'en-cao'},
    {name: 'English (Costa Rica)', code: 'en-cr'},
    {name: 'English (Guatemala)', code: 'en-gt'},
    {name: 'English (Hong Kong)', code: 'en-hk'},
    {name: 'English (Japan)', code: 'en-jp'},
    {name: 'English (Korea)', code: 'en-kr'},
    {name: 'English (Mexico)', code: 'en-mx'},
    {name: 'English (Malaysia)', code: 'en-my'},
    {name: 'English (French Polynesia)', code: 'en-pf'},
    {name: 'English (Singapore)', code: 'en-sg'},
    {name: 'English (Taiwan)', code: 'en-tw'},
    {name: 'English (Other)', code: 'en-gac'},
    {name: 'English (Brazil)', code: 'en-br'},
    {name: 'English (Philippines)', code: 'en-ph'},
    {name: 'English (Colombia)', code: 'en-co'},
    {name: 'English (Ecuador)', code: 'en-ec'},
    {name: 'English (Romania)', code: 'en-ro'},
    {name: 'English (France)', code: 'en-fr'},
    {name: 'English (South Africa)', code: 'en-za'},
    {name: 'Hebrew (Israel)', code: 'he-il'},
    {name: 'English (Panama)', code: 'en-pa'},
    {name: 'English (United Arab Emirates)', code: 'en-ae'},
    {name: 'Arabic (United Arab Emirates)', code: 'ar-ae'},
    {name: 'Spanish (El Salvador)', code: 'es-sv'},
    {name: 'English (Netherlands)', code: 'en-nl'},
    {name: 'Spanish (United States)', code: 'es-us'},
    {name: 'Thai (Thailand)', code: 'th-th'},
    {name: 'English (Thailand)', code: 'en-th'},
    {name: 'French (Canada)', code: 'fr-ca'},
    {name: 'Hebrew (Israel)', code: 'he-il'},
    {name: 'Hebrew (Other)', code: 'he-gac'},
    {name: 'Japanese (Japan)', code: 'ja-jp'},
    {name: 'Japanese (Other)', code: 'ja-gac'},
    {name: 'Korean (Republic of Korea)', code: 'ko-kr'},
    {name: 'Korean (Other)', code: 'ko-gac'},
    {name: 'Russian (Russia)', code: 'ru-ru'},
    {name: 'Russian (Israel)', code: 'ru-il'},
    {name: 'Russian (Kazakhstan)', code: 'ru-kz'},
    {name: 'Russian (Other)', code: 'ru-gac'},
    {name: 'Chinese (China)', code: 'zh-cn'},
    {name: 'Chinese (Hong Kong)', code: 'zh-hk'},
    {name: 'Chinese (Singapore)', code: 'zh-sg'},
    {name: 'Chinese (Taiwan)', code: 'zh-tw'},
    {name: 'Chinese (Other)', code: 'zh-gac'},
];

function extractLanguage(language) {
    if (language.includes("_")) {
        language = language.split(/_(.+)/)[1].toLowerCase().replace('_', '-');
    }

    return language;
}

function validateLanguage(language, region) {
    if (language.includes('_')) {
        language = language.replace('_', '-');
    }

    if (language.length === 2) {
        language = language + "-" + region;
    }

    if (_.has(_.mapKeys(LANGUAGES, 'code'), language)) {
        if (!_.has(REGIONS[region].languages, language)) {
            language = region.defaultLanguage;
        }
    } else {
        language = REGIONS[region].defaultLanguage;
    }

    return language;
};

EMAIL_TEMPLATE_LANGUAGES = [
    {name: 'English', code: 'en',},
    {name: 'Arabic', code: 'ar',},
    {name: 'Chinese (China)', code: 'zh-cn',},
    {name: 'Chinese (Hong Kong)', code: 'zh-hk',},
    {name: 'Chinese (Taiwan)', code: 'zh-tw',},
    {name: 'Czech', code: 'cs',},
    {name: 'Danish', code: 'da',},
    {name: 'Dutch', code: 'nl',},
    {name: 'French', code: 'fr',},
    {name: 'German', code: 'de',},
    {name: 'Hebrew', code: 'he',},
    {name: 'Hungarian', code: 'hu',},
    {name: 'Italian', code: 'it',},
    {name: 'Japanese', code: 'ja',},
    {name: 'Korean', code: 'ko',},
    {name: 'Norwegian', code: 'no',},
    {name: 'Portuguese', code: 'pt',},
    {name: 'Portuguese (Brazil)', code: 'pt-br',},
    {name: 'Romanian', code: 'ro',},
    {name: 'Russian', code: 'ru',},
    {name: 'Spanish', code: 'es',},
    {name: 'Spanish (Mexico)', code: 'es-mx',},
    {name: 'Slovenian', code: 'sl',},
    {name: 'Swedish', code: 'sv',},
    {name: 'Bulgarian', code: 'bg',},
    {name: 'Slovak', code: 'sk',},
]
